export default __webpack_public_path__ + "media/images/cta_blocks/recommend_hotels-8a70f1fdeaebc36d1a84234c1feb2621.jpg";